import type { PlatformUserRow, TranslationKey } from '@worki/shared';

/** The account a delete is about, as much of it as the wording needs. */
export type RemovalTarget = Pick<PlatformUserRow, 'name' | 'businessName' | 'lastInBusiness'>;

/** What the delete dialog says, which depends on how much the delete takes. */
export interface RemovalCopy {
  title: TranslationKey;
  message: TranslationKey;
  /** Both sentences name the person; only the business one names the business. */
  vars: { name: string; business: string };
  /** The line shown once it is done. */
  done: TranslationKey;
}

/**
 * ADM-002 — the last account in a business *is* the business, so deleting it
 * deletes the customers, the quotes, the invoices, the documents and the files
 * with it, the way the customer's own deletion does (ACCT-DEL). Said afterwards
 * that is a receipt; the dialog has to say it while it is still a question.
 *
 * `null` is the dialog on its way out — it stays mounted while it closes, and
 * the gentler wording is the right thing for it to be holding then.
 */
export function removalCopy(target: RemovalTarget | null): RemovalCopy {
  const vars = { name: target?.name ?? '', business: target?.businessName ?? '' };

  if (!target?.lastInBusiness) {
    return { title: 'admin.users.remove', message: 'admin.users.removeConfirm', vars, done: 'admin.users.removed' };
  }

  return {
    title: 'admin.users.removeBusiness',
    message: 'admin.users.removeBusinessConfirm',
    vars,
    done: 'admin.users.removedBusiness',
  };
}
